export const CAMPAIGN_NAME = 'name';
export const CAMPAIGN_ALTERNATIVE_ID = 'alternativeId';
export const CAMPAIGN_PLATFORM_ID = 'platformId';
export const CAMPAIGN_COST_MODELS = 'costModels';
export const CAMPAIGN_TYPE = 'type';
export const CAMPAIGN_TYPE_ID = 'id';
export const GENERATE_NAME_AUTOMATICALLY = 'generateNameAutomatically';
